/**
 * Convert a 2-letter ISO country code to a flag emoji.
 * e.g. "GB" → 🇬🇧, "US" → 🇺🇸
 *
 * @param {string} countryCode - ISO 3166-1 alpha-2 code
 * @returns {string} Flag emoji, or "🌍" if the code is invalid/missing
 */
export function countryCodeToFlag(countryCode) {
    if (!countryCode || countryCode.length !== 2) {
        return '🌍';
    }

    const code = countryCode.toUpperCase();
    const offset = 0x1f1e6 - 65; // Regional Indicator 'A' minus char code of 'A'

    return String.fromCodePoint(code.charCodeAt(0) + offset, code.charCodeAt(1) + offset);
}

const countryNames =
    typeof Intl !== 'undefined' && Intl.DisplayNames ? new Intl.DisplayNames(['en'], { type: 'region' }) : null;

/**
 * Get the full English name for a 2-letter ISO country code.
 * e.g. "GB" → "United Kingdom", "DE" → "Germany"
 *
 * @param {string} countryCode - ISO 3166-1 alpha-2 code
 * @returns {string} Full country name, or "Unknown" if unavailable
 */
export function countryCodeToName(countryCode) {
    if (!countryCode || countryCode.length !== 2) {
        return 'Unknown';
    }

    try {
        return countryNames?.of(countryCode.toUpperCase()) || countryCode;
    } catch {
        return countryCode;
    }
}
